import { render, staticRenderFns } from "./FeaturedVideos.vue?vue&type=template&id=4b82bf38&scoped=true&"
import script from "./FeaturedVideos.vue?vue&type=script&lang=js&"
export * from "./FeaturedVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b82bf38",
  null
  
)

export default component.exports